module.exports = __webpack_public_path__ + "img/L-boy.9e6e5168.png";